// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#000","subMenuActiveText":"#fec400","menuBg":"#304156","menuHover":"rgba(254,196,0,0)","subMenuBg":"#1f2d3d","subMenuHover":"rgba(254,196,0,0)","sideBarWidth":"240px","newMenuBg":"#010101"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 43